import {observer} from "mobx-react-lite"
import React, {useEffect} from "react"
import { Link } from "react-router-dom"
import {attributesCompare} from "./AttributesCompare"
import {appPages} from "../../App";

export const CategoriesForAttributes = observer(() => {
    useEffect(() => {
        if (!attributesCompare.isCategoriesLoad){
            attributesCompare.loadCategories()
        }
    }, [])
    return <table>
        <thead style={{backgroundColor: "#F3F3F3"}}>
        <tr>
            <th>Категория</th>
            <th>Сопоставлено обязательных параметров</th>
            <th>Товаров в выгрузке</th>
        </tr>
        </thead>
        <tbody>
            {attributesCompare.isCategoriesLoad && attributesCompare.categories.map((category, i) => {
                return <tr key={i}>
                    <td className="custom-px-0">
                        <Link className={'underline gray'} to={appPages.offerAttributes + '/category/' + category.id}>{category.fullTitle}</Link>
                    </td>
                    <td>
                        {category.countRequiredWithRules}/{category.requiredCount}
                    </td>
                    <td>
                        {category.productCount}
                        {category.collection_url && <a
                            className={"custom-ml-4 gray smaller"}
                            href={category.collection_url}
                            target={"_blank"}
                            rel="noopener noreferrer">
                            <i className="fas fa-external-link-alt" aria-hidden="true"/>
                        </a>}
                    </td>
                </tr>
            })}
        </tbody>
    </table>
})